import React from 'react';
const DescriptionsContext = /*#__PURE__*/React.createContext(null);
export default DescriptionsContext;